<template>
  <div class="grid-box">
    <!-- 投标模块 -->
    <div v-for="(paItem,i) in menuData" :key="i" class="items-box">
      <!-- 模块名称 -->
      <div class="grid-title">{{paItem.menu_name}}</div>
      <!-- 模块名称结束 -->
      <!-- 头标展示区 -->
      <van-grid square :column-num="4" :border="false" icon-size="1rem">
        <van-grid-item
          v-for="(item,index) in paItem.list"
          :key="index"
          :icon="item.file_url"
          :text="item.menu_name"
          :url="item.menu_href"
          :class="{'border':item.border}"
        />
      </van-grid>
      <!-- 头标展示区结束 -->
    </div>
    <!-- 投标模块结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    menuList: {
      type: Array
    }
  },
  watch: {
    menuList(val) {
      this.menuData = val; //给展示的list赋值
    }
  },
  data() {
    return {
      menuData: [] //接收父组件传递过来的menu数据
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化函数
    init() {
      this.gianListData();
    },
    // 给展示的list赋值
    gianListData() {
      this.menuData = this.menuList;
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/reset.css';

.grid-box {
  .items-box {
    background: #fff;
    margin-bottom: 10px;
    padding-top: 10px;
  }


  .grid-title {
    color: #353535;
    font-size: 17px;
    padding: 0px 15px 0;
    font-size: 17px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 24px;
  }

  .border {
    margin-bottom: 10px;

    div {
      border: 2px dashed #e5e5e5;
      width: 66%;
      margin: auto;
    }
  }
}
</style>